module.exports = __webpack_public_path__ + "img/img4.3c8616c8.png";